import dialog from './dialog'
import env from './env'
import { store } from '@/store'
import AgTutorialModal from '@/components/Modal/Tutorial'

function openDialog (type) {
  return dialog.component(AgTutorialModal, { type }, env.isSmallScreen())
}

async function check(type) {
  let entry = store.state.tutorial?.find(t => t.type === type)
  
  // Wenn es bereits einen Eintrag gibt und das Datum noch nicht überschritten ist, dann hochzählen
  if (entry) {
    (Date.now() - (30 * 86400000)) < entry.lastDate ? entry.count++ : entry.count = 2
  } else {
    entry = {
      type,
      count: 0,
    }
  }
  
  if (entry.count <= 2) {
    await openDialog(type)
    entry.lastDate = Date.now()
  }
  
  store.commit('setTutorial', entry)
}

export default {
  openDialog,
  check
}